import { render, staticRenderFns } from "./TransferProposal.vue?vue&type=template&id=e225a340"
import script from "./TransferProposal.vue?vue&type=script&lang=js"
export * from "./TransferProposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports